import CryptoJS from "crypto-js";

// --- Request encryption key (Node server ke REQUEST key se match honi chahiye) ---
const reqKey = CryptoJS.enc.Utf8.parse(
  process.env.REACT_APP_SECRET_KEY_REQUEST || "",
);
const reqIv = CryptoJS.enc.Utf8.parse(process.env.REACT_APP_IV_REQUEST || "");

// --- Response decryption key (Node server ke RESPONSE key se match honi chahiye) ---
const resKey = CryptoJS.enc.Utf8.parse(
  process.env.REACT_APP_SECRET_KEY_RESPONSE || "",
);
const resIv = CryptoJS.enc.Utf8.parse(process.env.REACT_APP_IV_RESPONSE || "");

export const encryptData = (data) => {
  const encrypted = CryptoJS.AES.encrypt(JSON.stringify(data), reqKey, {
    iv: reqIv,
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.Pkcs7,
  });
  return encrypted.toString();
};

export function decryptData(encryptedText) {
  if (!encryptedText || typeof encryptedText !== "string") {
    return {
      success: "3",
      message: "Invalid Details",
      reason: "Missing or non-string encrypted data",
    };
  }

  let decrypted;
  try {
    decrypted = CryptoJS.AES.decrypt(
      { ciphertext: CryptoJS.enc.Base64.parse(encryptedText) },
      resKey,
      { iv: resIv, mode: CryptoJS.mode.CBC, padding: CryptoJS.pad.Pkcs7 },
    );
  } catch (err) {
    console.error("AES decrypt threw:", err.message);
    return {
      success: "3",
      message: "Invalid Details",
      reason: "Decryption failed",
    };
  }

  let decryptedText;
  try {
    decryptedText = decrypted.toString(CryptoJS.enc.Utf8);
  } catch (err) {
    console.error("UTF-8 conversion failed:", err.message);
    return {
      success: "3",
      message: "Invalid Details",
      reason: "Wrong key/IV or corrupted data",
    };
  }

  if (!decryptedText) {
    return {
      success: "3",
      message: "Invalid Details",
      reason: "Empty result after decryption",
    };
  }

  try {
    const decodedJson = JSON.parse(decryptedText);
    return { success: "1", data: decodedJson };
  } catch (err) {
    console.error("JSON parse failed:", err.message);
    return {
      success: "3",
      message: "Invalid Details",
      reason: "Invalid JSON after decryption",
    };
  }
}
